var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout-vr",staticStyle:{"min-width":"1366px"}},[_c('el-container',[_c('el-header',[_c('Navbar')],1),_c('el-main',{staticClass:"layoutmain"},[_c('AppMain')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }